import { useSeo } from "@/lib/seo";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { PageHeader, Note } from "@/components/Bits";

const HIERARCHY = ["Brand", "Organization", "Location"];

const Enterprise = () => {
  useSeo({
    title: "Enterprise",
    description: "MONOE is built around Brand → Organization → Location, with combined reporting and franchise-aware data separation.",
    path: "/enterprise",
  });

  return (
    <div>
      <PageHeader
        eyebrow="Enterprise"
        title="From a single shop to a multi-location brand."
        intro="MONOE is built around Brand → Organization → Location. Group your locations under one brand, see combined sales across every location, and run rewards scoped to a single location or all locations you own."
        testId="enterprise-hero"
      />
      <section>
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
          <Reveal>
            <div className="flex flex-wrap items-center gap-2">
              {HIERARCHY.map((h, i) => (
                <div key={h} className="flex items-center gap-2">
                  <span className="rounded-full border border-border bg-card px-4 py-2 text-sm font-medium">{h}</span>
                  {i < HIERARCHY.length - 1 && <ArrowRight className="h-4 w-4 text-muted-foreground" />}
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.06}>
            <Note testId="enterprise-note">
              Franchise-aware by design: independently owned franchisees don't automatically share
              financial, employee, or private business data, and one franchisee can't create a reward
              that obligates another.
            </Note>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Enterprise;
